import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'antd';
import { NamePath } from 'antd/lib/form/interface';

import CountryInput from './CountryInput';
import { Form } from '~/components';
import { useBusinessDocumentTypeParameters } from '~/hooks/useHandbook';
import DateInput from './DateInput';

interface Props {
  nameFn?: (name: string) => NamePath;
  countryId: string | undefined;
  legalType: string | undefined;
  documentType: string | undefined;
  labelsVariant?: 'label' | 'placeholder';
  [x: string]: any;
}

const BusinessDocumentParametersInputGroup: FC<Props> = (props) => {
  const { nameFn, countryId, legalType, documentType, labelsVariant = 'label', ...rest } = props;
  const [t] = useTranslation('documentTypeParameters');
  const { data } = useBusinessDocumentTypeParameters({ countryId, legalType, documentType });

  return (
    <>
      {data.map((item) => {
        const { name, mandatory, type } = item;
        return (
          <Form.Item
            {...rest}
            key={name}
            name={nameFn ? nameFn(name) : name}
            label={labelsVariant === 'label' ? t(name) : undefined}
            rules={[{ required: mandatory }]}
          >
            {(() => {
              switch (type) {
                case 'date':
                case 'pastDate':
                case 'futureDate':
                  return (
                    <DateInput
                      placeholder={labelsVariant === 'placeholder' ? t(name) : undefined}
                      disableDateRule={
                        type === 'pastDate'
                          ? 'date <= today'
                          : type === 'futureDate'
                          ? 'date > today'
                          : undefined
                      }
                    />
                  );
                case 'text':
                  return (
                    <Input placeholder={labelsVariant === 'placeholder' ? t(name) : undefined} />
                  );
                case 'country':
                  return (
                    <CountryInput
                      placeholder={labelsVariant === 'placeholder' ? t(name) : undefined}
                    />
                  );
                default:
                  return (
                    <Input placeholder={labelsVariant === 'placeholder' ? t(name) : undefined} />
                  );
              }
            })()}
          </Form.Item>
        );
      })}
    </>
  );
};

export default BusinessDocumentParametersInputGroup;
